import { generateTranslationHook } from "../utils/translation-hook-generator";

export type MarketingSectionsHeroMessages =
	typeof import("../../../locales/en/marketing/sections/hero.json");

export const useMarketingSectionsHeroTranslations =
	generateTranslationHook<MarketingSectionsHeroMessages>(
		"marketing.sections.hero"
	);
